// utils/mimeTypes.js
export function getMimeType(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    const mimeTypes = {
        'stp': 'application/step',
        'step': 'application/step',
        'stl': 'application/sla', // 필요에 따라 다른 MIME 타입으로 변경 가능
        'pdf': 'application/pdf',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'txt': 'text/plain',
        'hwp': 'application/x-hwp'
        

        
        // 추가적인 확장자와 MIME 타입을 여기에 추가
    };
    return mimeTypes[extension] || 'application/octet-stream'; // 기본값 설정
}





